import React, { PureComponent } from 'react';
import uniqueId from 'lodash/uniqueId';


export default class BaseField extends PureComponent {
  constructor(props) {
    super(props);

    const { input: { name } } = props;
    this.state = { id: uniqueId(`${name}_`) };
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Field/Base.js